import * as React from 'react';

export interface WarningCircleIconProps extends React.SVGProps<SVGSVGElement> {
  className?: string;
}

/**
 * Orange warning circle with a white "!" — the confirmation-modal glyph from
 * the Noor-CPanel Figma file (node 749:19565). Fixed brand tints (orange-600
 * body), so — unlike the monochrome `Menu*Icon` glyphs — it does not follow
 * `currentColor`; callers size it with `size-*` (native frame 72×72).
 */
export function WarningCircleIcon({ className, ...props }: WarningCircleIconProps) {
  return (
    <svg
      viewBox="0 0 72 72"
      fill="none"
      aria-hidden="true"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle cx="36" cy="36" r="36" fill="#FF6D00" />
      <rect x="32" y="14" width="8" height="26" rx="4" fill="white" />
      <circle cx="36" cy="51" r="5" fill="white" />
    </svg>
  );
}
